// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const HistoryIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="HistoryIcon" ref={forwardedRef} {...props}>
      <path d="M1.779 8.65 3 9.872a8 8 0 1 1 6.996 8.065l-.002-1.515A6.6 6.6 0 0 0 11 16.499a6.47 6.47 0 0 0 4.062-1.425A6.49 6.49 0 0 0 17.5 10a6.49 6.49 0 0 0-2.438-5.075 6.5 6.5 0 0 0-10.56 4.963L5.738 8.65l.848.848-2.828 2.829L.93 9.498z" />
      <path d="M10 7h1.5v3.5H14V12h-4z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const HistoryIcon = /* @__PURE__ */ Object.assign(HistoryIconComponent, {
  displayName: 'HistoryIcon',
});
